export const parseNetworkError = (err) => {
  return err.networkError && err.networkError.result
    ? err.networkError.result.errors[0].message
    : "Sorry! Something went wrong while uploading your csv. Please try again later.";
};
